import { useEffect, useState } from "react";
import { CheckCircle2, CircleDashed } from "lucide-react";
import { api } from "../../lib/api";
import { fmtDateTimeMtl } from "../../lib/dateMtl";

// Crochet « Webhook Stripe » (demande du propriétaire, 2026-10-16) : devient
// VERT dès le premier VRAI événement signé reçu (test ou production indiqué) —
// prouve que le Dashboard Stripe pointe au bon endroit. Gris tant que rien
// n'est arrivé.
export default function WebhookStatutChip() {
  const [st, setSt] = useState(null);
  const [ouverte, setOuverte] = useState(false);
  useEffect(() => {
    api.get("/admin/stripe-webhook-statut").then(({ data }) => setSt(data)).catch(() => setSt({ vu: false }));
  }, []);
  if (!st) return null;
  const evenements = [...(st.evenements || [])].reverse();  // plus récent d'abord
  return (
    <div data-testid="webhook-statut" className="mb-4">
      <button type="button" onClick={() => setOuverte((v) => !v)} data-testid="webhook-statut-toggle"
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs transition-colors duration-300 ${
          st.vu ? "border-emerald-400/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20"
                : "border-ivory/20 bg-surface text-ivory/60 hover:border-ivory/40"}`}>
        {st.vu ? <CheckCircle2 className="w-3.5 h-3.5" /> : <CircleDashed className="w-3.5 h-3.5" />}
        {st.vu
          ? <>Webhook Stripe actif — dernier événement : <strong>{st.dernier_type}</strong>
              {st.dernier_at ? ` · ${fmtDateTimeMtl(st.dernier_at)}` : ""}
              {` · mode ${st.livemode ? "production" : "test"}`}{st.count > 1 ? ` · ${st.count} reçus` : ""}</>
          : "Webhook Stripe : aucun événement reçu encore — pointez le Dashboard vers /api/stripe/webhook"}
      </button>
      {/* Audit (demande du propriétaire, 2026-10-16) : les 10 derniers événements */}
      {ouverte && evenements.length > 0 && (
        <div className="mt-2 bg-surface border border-ivory/10 rounded-lg px-4 py-3 max-w-xl"
          data-testid="webhook-historique">
          {evenements.map((e, i) => (
            <p key={i} data-testid={`webhook-event-${i}`} className="text-xs text-ivory/70 py-0.5 flex gap-3">
              <span className="text-ivory/40 shrink-0">{fmtDateTimeMtl(e.at)}</span>
              <span className="flex-1">{e.type}</span>
              <span className={e.livemode ? "text-emerald-300" : "text-amber-300/80"}>
                {e.livemode ? "production" : "test"}
              </span>
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
